import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimConfigurationItemTransformationType extends IModelBase {
  Name: string
  Description: string
  FabricUri: string
}

@Injectable()
export class ClaimConfigurationItemTransformationTypeODataService extends ODataService<IClaimConfigurationItemTransformationType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimConfigurationItemTransformationTypes'
  }
}
